
import Vue from 'vue';
import Hero from '~/components/index/hero.vue'
import {PageInterface} from "~/store/page"

export default Vue.extend({
  name: 'LocationOverviewPage',
  components: {Hero},
  head() {
    return {
      title: this.$data.seoTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$data.seoDescriptionMeta,
        }
      ],
    }
  },
  data(): { pages: PageInterface[] | null, heroTitle: string, friendlyType: string, seoTitle: string, seoDescriptionMeta: string } {
    return {
      pages: null,
      heroTitle: '',
      friendlyType: "",
      seoTitle: "",
      seoDescriptionMeta: "",
    }
  },
  async fetch() {
    const type = this.$route.params.type;
    const slugPrefix = type + '-';

    let friendlyType = type.charAt(0).toUpperCase() + type.slice(1);
    friendlyType = friendlyType.replaceAll('-', ' ');

    this.heroTitle = friendlyType + ' voor elke gelegenheid';

    this.$data.friendlyType = friendlyType;
    this.$data.seoTitle = `${friendlyType} locaties vind je hier - CHEFSTBL`;
    this.$data.seoDescriptionMeta = `${friendlyType} boek je via CHEFSTBL! Bekijk hier het ruime aanbod van ${friendlyType} locaties en plan je ideale diner.`;

    // @ts-ignore
    this.pages = await this.$axios.$get<{ data: PageInterface[] }>(`/v1/page?filter[slug]=${slugPrefix}`).then(data => data.data);
  }
});
